import {mergeTo} from '#core/utils/config-utils.js';

import {AbstractFeature, allFeatures} from '#core/application/abstract-feature.js';

import SCHEMA from './currencies.schema.yaml';

class CurrenciesFeature extends AbstractFeature {
    get configSchema() {
        return SCHEMA;
    }

    updateViewsConfig(viewsConfig) {
        mergeTo(viewsConfig, {Currencies: this.config});

        super.updateViewsConfig(viewsConfig);
    }
}

new CurrenciesFeature(allFeatures);
